<div class="d-flex">
  <ng-content select="product-image"></ng-content>

  <div class="flex-grow-1">
    <ng-content select="product-header"></ng-content>
    <ng-content select="product-description"></ng-content>
    <ng-content select="product-allergens"></ng-content>
    <ng-content select="chosen-options"></ng-content>
    <ng-content select="menu-chosen-products"></ng-content>
    <ng-content select="[availability]"></ng-content>
  </div>

  <ng-content select="product-counter"></ng-content>
</div>
